var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "items-list--item" },
    [
      _c(
        "b-row",
        { attrs: { "align-v": "center" } },
        [
          _c("b-col", { attrs: { md: "3" } }, [
            _c("div", { staticClass: "items-list--item-label" }, [
              _vm._v("Person")
            ]),
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.exclusion.pseudonym.label) + "\n\t\t"
            )
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { md: "8" } }, [
            _c("div", { staticClass: "items-list--item-label" }, [
              _vm._v("Ausgeschlossen")
            ]),
            _vm._v(" "),
            _c("div", [
              _vm.exclusion.validUntil
                ? _c("span", [
                    _vm._v(
                      "bis " + _vm._s(_vm._f("date")(_vm.exclusion.validUntil))
                    )
                  ])
                : _c("span", [_vm._v("unbefristet")]),
              _vm._v("\n\t\t\t\t| " + _vm._s(_vm.typeLabel) + "\n\t\t\t")
            ])
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "text-right", attrs: { md: "1" } }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.remove = true
                  }
                }
              },
              [
                _c("Icon", {
                  attrs: { icon: "bin", size: "1comma5x", color: "primary" }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.remove
        ? _c("RemovePopUp", {
            attrs: { exclusion: _vm.exclusion },
            on: {
              remove: function($event) {
                return _vm.$emit("remove")
              },
              hidden: function($event) {
                _vm.remove = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }